import { Switch } from "@mui/material";
import React, { useState } from "react";
import PanelTemplate from "../../../shares/PanelTemplate";
import { useSetting } from "../../../../context/SettingContext";

const ProviderSetParameter = () => {
  const {
    showNumSix,
    reverseShowNums,
    onchange_showNumSix,
    onchange_reverseShowNums,
  } = useSetting();

  const [leftOrRight, setLeftOrRight] = useState(reverseShowNums);
  const [sixYesOrNo, setSixYesOrNo] = useState(showNumSix);

  const handle_switch_leftright_change = (event) => {
    setLeftOrRight(event.target.checked);
    onchange_reverseShowNums(event.target.checked);
  };
  const handle_switch_sixnumber_change = (event) => {
    setSixYesOrNo(event.target.checked);
    onchange_showNumSix(event.target.checked);
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="parameter">
        <>
          <div className="panel-main-header">
            <span>تنظیمات نمایش </span>
          </div>
          <div className="border-container md:border-container md:flex md:flex-row md:justify-between">
            <div className="flex flex-col md:flex md:flex-row">
              <span className="ml-2 mt-1">چیدمان ستون های جدول :</span>
              {leftOrRight ? (
                <span className="mt-1">از چپ به راست</span>
              ) : (
                <span className="mt-1">از راست به چپ</span>
              )}
              <Switch
                onChange={handle_switch_leftright_change}
                checked={leftOrRight}
              />
            </div>
            <div>
              <span className="ml-2">وضعیت سایز ششم:</span>
              {sixYesOrNo ? <span> فعال</span> : <span>غیر فعال</span>}

              <Switch
                onChange={handle_switch_sixnumber_change}
                checked={sixYesOrNo}
              />
            </div>
          </div>
        </>
      </PanelTemplate>
    </>
  );
};

export default ProviderSetParameter;
